import React from 'react';
import { TERMS_URL, TERMS_AND_CONDITIONS_URL, PRIVACY_POLICY_URL } from '@/constants';

interface LegalAgreementProps {
	variant?: 'default' | 'probability-event';
}

export const LegalAgreement = ({ variant = 'default' }: LegalAgreementProps) => {
	if (variant === 'probability-event') {
		return (
			<p className="text-xs text-[#B5B6BA] text-center max-w-xs leading-normal">
				By continuing, you agree to
				<br />
				Sportspredict's
				<br />
				<a
					href={TERMS_URL}
					target="_blank"
					rel="noopener noreferrer"
					className="text-[#81A1F8] underline hover:text-[#ACC0F6]"
				>
					Terms & Conditions
				</a>{' '}
				and{' '}
				<a
					href={PRIVACY_POLICY_URL}
					target="_blank"
					rel="noopener noreferrer"
					className="text-[#81A1F8] underline hover:text-[#ACC0F6]"
				>
					Privacy Policy
				</a>
				.
			</p>
		);
	}

	return (
		<p className="text-xs text-[#B5B6BA] text-center max-w-xs leading-normal">
			By continuing, you agree to our{' '}
			<a
				href={TERMS_AND_CONDITIONS_URL}
				target="_blank"
				rel="noopener noreferrer"
				className="text-[#81A1F8] underline hover:text-[#ACC0F6]"
			>
				Terms & Conditions
			</a>{' '}
			and{' '}
			<a
				href={PRIVACY_POLICY_URL}
				target="_blank"
				rel="noopener noreferrer"
				className="text-[#81A1F8] underline hover:text-[#ACC0F6]"
			>
				Privacy Policy
			</a>
			.
		</p>
	);
};
